export class Log {
  constructor({
        id= null,      
        userName= ``, 
        requestIp= ``,
        description= ``,
        browser= ``,
        time= ``,
        createTime= ``
    } = {}) {
    this.id = id;
    this.userName = userName;
    this.requestIp = requestIp;
    this.description = description;
    this.browser = browser;
    this.time = time;
    this.createTime = createTime;
  }
}
export function newEntity() {
  return new Log();
}
export function gridFields() {
  return Object.freeze([
      // {
      //   key: 'id',
      //   label: 'lbl.basic.id',
      //   notInTable: true,
      //   form: {
      //     type: 'input'
      //   }
      // },
      {
        key: 'userName',
        label: 'lbl.log.user',
        sortable: true,
        form: {
          type: 'input'
        }
      },      
      {
        key: 'description',
        label: 'lbl.log.description',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'requestIp',
        label: 'lbl.log.ip',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'browser',
        label: 'lbl.log.browser',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'time',
        label: 'lbl.log.time',
        sortable: true,
        form: {
          type: 'input'
        }
      },
      {
        key: 'createTime',
        label: 'lbl.log.createTime',
        sortable: true,
        form: {
          type: 'input'
        }
      }   
  ]);
}
export const fields = Object.freeze(Object.keys(new Log()).map(i => 'entity.' + i));

export const filterFields = [
  'filter.nameFilter',
  'filter.descriptionFilter',
  'filter.startTimeFilter',
  'filter.endTimeFilter'
];

export const filter = {
  'nameFilter': "",
  'descriptionFilter':"",
  'startTimeFilter':"",
  'endTimeFilter':""
};